import PostsFilters from './PostsFilters';

export default PostsFilters;
